import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { useCatalog } from '@/hooks/useCatalog';
import { useRevealOnScroll } from '@/hooks/useRevealOnScroll';
import { HomeHero } from '@/components/home/HomeHero';
import { ServicesSection } from '@/components/home/ServicesSection';
import { HowItWorks, BusinessSection, HomeFooter } from '@/components/home/HomeSections';
import ServiceAreaMap from '@/components/ServiceAreaMap';
import FaqSection from '@/components/FaqSection';
import ReviewRow from '@/components/ReviewRow';
import ServiceDetailDialog from '@/components/ServiceDetailDialog';
import QuoteRequestDialog from '@/components/QuoteRequestDialog';

export default function LandingPage() {
  const { services, loading, error, tenant } = useCatalog();
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState(null);
  const [activeService, setActiveService] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSticky, setShowSticky] = useState(false);
  const heroRef = useRef(null);
  useRevealOnScroll();
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setShowSticky(!entry.isIntersecting && entry.boundingClientRect.bottom < 0));
    if (heroRef.current) observer.observe(heroRef.current);
    return () => observer.disconnect();
  }, []);
  const openQuote = (service = null) => { setQuoteService(service); setQuoteOpen(true); };
  return (
    <div className="e-home" data-testid="landing-page">
      <HomeHero heroRef={heroRef} onQuote={() => openQuote()} onMenuChange={setMenuOpen} />
      <ServicesSection services={services} loading={loading} error={!!error} onRetry={() => window.location.reload()} onQuote={openQuote} onDetails={setActiveService} />
      <HowItWorks />
      <section className="e-reviews" data-testid="home-reviews-section"><div className="e-container"><div className="e-section-head"><p className="e-eyebrow">Fra vores kunder</p><h2>God service gør en forskel.</h2></div><ReviewRow compact /></div></section>
      <ServiceAreaMap />
      <BusinessSection />
      <FaqSection />
      <HomeFooter tenant={tenant} />
      <ServiceDetailDialog service={activeService} open={!!activeService} onOpenChange={(open) => { if (!open) setActiveService(null); }} />
      <QuoteRequestDialog key={quoteService?.id || 'custom'} open={quoteOpen} onOpenChange={setQuoteOpen} service={quoteService} allServices={services} />
      {showSticky && !quoteOpen && !activeService && !menuOpen && createPortal(
        <div className="e-mobile-book" data-testid="sticky-mobile-book-bar"><Link to="/book" className="e-button" data-testid="sticky-book-btn">Book tid</Link></div>, document.body
      )}
    </div>
  );
}